<div class="popup-container">

<header>
  <label class="close_button" (click)="close()">x</label>
  <div class="header d-block roboto-medium">
    <label class="ms-3 mt-3 mb-3">{{heading}}</label>
  </div>
</header>

<!-- <form #contactForm="ngForm" (ngSubmit)="afterSubmit(contactForm)"> -->


<div class="body" [style]="errormsg ? 'margin-bottom: 0%;' : 'margin-bottom: 0%;'">
  <div class="m-3 ms-4 me-4">
    <div class="row mb-3">
      <div class="col-4 d-flex">
        <label class="catlabel col-5">Route Name:</label>
        <input class="category col-7" type="text" [(ngModel)]="routeName" [disabled]="true" />
      </div>
      <div class="col-4 d-flex">
        <label class="catlabel col-5" for="input2">Planned Unload:</label>
        <input class="category col-7" type="text" [(ngModel)]="plannedDate" [disabled]="true" />
      </div>
      <div class="col-4 d-flex">
        <label class="catlabel col-5 star-icon" for="input3">Incident Date:</label>
        <input class="category col-7" type="date" [(ngModel)]="incidentDate" />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-4 d-flex">
        <label class="catlabel col-5 " for="input4">Incident Time:</label>
        <div class="category col-7">
          <ngx-timepicker-field [(ngModel)]="incidentTime" class="form-control timepicker" [format]="24"
            [defaultTime]="'00:00'"></ngx-timepicker-field>
        </div>
      </div>

      <div class="col-4 d-flex">
        <label class="catlabel col-5 star-icon" for="input4">LP:</label>
        <select [(ngModel)]="lp" [ngModelOptions]="{ standalone: true }" class="category col-7">
          <option *ngFor="let eachplantList of lpDropDown" [value]="eachplantList.label">
            {{ eachplantList.value }}
          </option>
        </select>
      </div>
      <div class="col-4 d-flex">
        <label class="catlabel col-5 star-icon" for="input5">Region:</label>
        <select [(ngModel)]="region" [ngModelOptions]="{ standalone: true }" class="category col-7">
          <option *ngFor="let eachplantList of regionDropDown" [value]="eachplantList.value">
            {{ eachplantList.value }}
          </option>
        </select>
      </div>
      <!-- <div class="col-4 d-flex">
        <label class="catlabel col-5" for="input6">Severity:</label>
        <select [(ngModel)]="severity" [ngModelOptions]="{ standalone: true }" class="category col-7">
          <option *ngFor="let eachplantList of severityDropDown" [value]="eachplantList.value">
            {{ eachplantList.value }}
          </option>
        </select>
      </div> -->
    </div>
    <div class="row mb-3">
      <div class="col-4 d-flex">
        <label class="catlabel col-5 star-icon" for="input6">Severity:</label>
        <select [(ngModel)]="severity" [ngModelOptions]="{ standalone: true }" class="category col-7">
          <option *ngFor="let eachplantList of severityDropDown" [value]="eachplantList.value">
            {{ eachplantList.value }}
          </option>
        </select>
      </div>
      <div class="col-4 d-flex">
        <label class="catlabel col-5">Report Type:</label>
        <input class="category col-7" type="text" [(ngModel)]="reportType" [disabled]="true" />
      </div>
      <div class="col-4 d-flex">
        <label class="catlabel col-5 star-icon" for="input5">Trailer:</label>
        <input class="category col-7" type="text" [(ngModel)]="trailer" />
      </div>
      <!-- <div class="col-4 d-flex">
        <label class="catlabel col-5" for="input6">Incident Summary:</label>
        <textarea class="category col-7" rows="4" placeholder="Comments" #myInput [(ngModel)]="comments"></textarea>
      </div> -->
    </div>
    <div class="row mb-3">
      <div class="col-4 d-block">
        <div class="d-flex">

          <label class="catlabel col-5 star-icon" for="input6">Incident Summary:</label>
          <textarea class="category col-7" [maxLength]="1000" rows="4" placeholder="Comments" name="myInput1"  required  ngModel #myInput1Ref="ngModel" [(ngModel)]="comments"></textarea>
        </div>
        <div class="d-flex">
          <div class="col-5"></div>
        <p id="charCounter" class="catlabel col-7"> Character Limit: {{maxi-myInput1Ref.value?.length}} left</p>
        </div>
        <div class="d-flex">
          <div class="col-5"></div>
        <p *ngIf="myInput1Ref?.invalid && check   "  id="charCounter" class="catlabel col-7 production_checkMessage"> Provide Incident Summary</p>
        </div>

      </div>
      <div class="col-4"></div>
      <div class="col-4"></div>
    </div>
  </div>

  <div class="myDiv mt-3">
    <div class="d-flex p-2 ps-3">
      <label class="star-icon"><b> INCIDENT TYPE (Due within 48 hours) </b> </label>
    </div>
  </div>

  <div class="row m-3">
    <div class="col-2">
      <label class="checkcontainer">Fatality
        <input class="checkbox" type="checkbox"   value="FATALITY" (change)="onInputBoxChanged($event)"
          [checked]="Fatality == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Amputation
        <input class="checkbox" type="checkbox"    value="AMPUTATION" (change)="onInputBoxChanged($event)"
          [checked]="Amputation == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Loss of hearing
        <input class="checkbox" type="checkbox"   value="LOSS OF HEARING" (change)="onInputBoxChanged($event)"
          [checked]="LOH == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Fracture
        <input class="checkbox" type="checkbox"   value="FRACTURE" (change)="onInputBoxChanged($event)"
          [checked]="Fracture == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Injury
        <input class="checkbox" type="checkbox"   value="INJURY" (change)="onInputBoxChanged($event)"
          [checked]="Injury == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Illness
        <input class="checkbox" type="checkbox"   value="ILLNESS" (change)="onInputBoxChanged($event)"
          [checked]="Illness == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Loss of sight
        <input class="checkbox" type="checkbox"   value="LOSS OF SIGHT" (change)="onInputBoxChanged($event)"
          [checked]="LOS == 4" />
        <span class="checkmark"></span>
      </label>
    </div>



    <div class="col-2">
      <label class="checkcontainer">Head Injury
        <input class="checkbox" type="checkbox"   value="HEAD INJURY" (change)="onInputBoxChanged($event)"
          [checked]="headInjuriry == 4" />
        <span class="checkmark"></span>
      </label>
    </div>

    <div class="col-2">
      <label class="checkcontainer">Hospitalization
        <input class="checkbox" type="checkbox"   value="HOSPITALIZATION" (change)="onInputBoxChanged($event)"
          [checked]="Hospitalisation == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Near miss/hit
        <input class="checkbox" type="checkbox"   value="NEAR MISS HIT" (change)="onInputBoxChanged($event)"
          [checked]="nearMiss == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Burn
        <input class="checkbox" type="checkbox"   value="BURN" (change)="onInputBoxChanged($event)"
          [checked]="Burn == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Stop 6
        <input class="checkbox" type="checkbox"   value="STOP" (change)="onInputBoxChanged($event)"
          [checked]="Stop6 == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Property Damage
        <input class="checkbox" type="checkbox"  value="PROPERTY DAMAGE" (change)="onInputBoxChanged($event)"
          [checked]="Property == 4" />
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="col-2">
      <label class="checkcontainer">Other
        <input class="checkbox" type="checkbox"   value="OTHER" (change)="onInputBoxChanged($event)"
          [checked]="Other == 4" />
        <span class="checkmark"></span>
      </label>
    </div>

  </div>
  <!-- ///////////// -->
  <div class="row m-3" id="message">
    <div class="col-4">
      <p *ngIf="incidentTypes.length==0  && check "> Please Choose at least one Incident Type</p>
      </div>

  </div>
  <!-- ////////// -->

  <div class="row m-3">
    <div class="col-12 d-flex pe-0">
      <label class="catlabel col-1 star-icon">Details:</label>
      <input class="category col-11 details" [maxLength]="2000" type="text" name="myInput2"  required  ngModel #myInput2Ref="ngModel"  [(ngModel)]="incidentTypeDetails" />
    </div>
    <div class="d-flex">
      <div class="col-5"></div>
    <p id="charCounter" class="catlabel col-7"> Character Limit: {{maxiDetails-myInput2Ref.value?.length}} left</p>
    </div>
  </div>
</div>
<!-- /////////////// -->


<!-- <div class="row m-3">
  <div class="col-12 d-flex pe-0" id="message">
    <label class="catlabel col-1"></label>
    <p *ngIf="myInput2Ref?.invalid && check "  > Provide Details</p>
  </div>
</div> -->


<!-- //////////////// -->
<div *ngIf="errormsg" class="errormsg"> {{ errormsg }} </div>

<div class="footer d-flex justify-content-between align-items-center fixed-bottom mt-2 py-2 ps-4">
  <button   *ngIf="deleteAccessible" class="deletebutt roboto-medium" (click)="deleteEvent()"> DELETE </button>
  <div class="d-flex">
    <button   class="cancel me-3 roboto-bold" (click)="close()"> CANCEL </button>
    <button  class="submit black-button me-3 roboto-medium" (click)="saveClick()" >UPDATE</button>
  </div>
  <!-- <div class="row" style="width: 100%;">
    <div class="col-6">
      <button  *ngIf = "deleteAccessible" class="deletebutt roboto-medium" (click)="deleteEvent()"> DELETE </button>
    </div>
    <div class="col-6" style="padding-right: 0px;">
      <button class="cancel me-3 roboto-bold" (click)="close()"> CANCEL </button>
      <button class="submit black-button me-3 roboto-medium"  (click)="saveClick()">UPDATE</button>

    </div>

  </div> -->
</div>

<!-- </form> -->
</div>